<template>
	<el-drawer :modal="false"  title="Transfer Balance" name="drawer-transfer" :visible.sync="show_drawer" class="drawer-transfer"
		size="40%">
		<b-container>
			<b-row align-v="center" class="py-3">
				<b-col cols="12">
					<p class="text-muted">Current Total Balance</p>
				</b-col>
				<b-col cols="6">
					<p class="text-muted">Report</p>
					<h2 class="listing-title mb-0">{{ remainBalanceReport }}</h2>
				</b-col>
				<b-col cols="6">
					<p class="text-muted">Points</p>
					<h2 class="listing-title mb-0">{{ remainBalancePoints }}</h2>
				</b-col>
			</b-row>
			<b-row align-v="center" class="py-3">
				<b-col cols="12">
					<b-form-group label="Transfer Balance Type:">
						<ValidationProvider v-slot="{ errors }" :rules="{ required: true }" :vid="'credit_type'">
							<el-select v-model="formParams.credit_type" placeholder="Select Type" @change="resetReciver()">
								<el-option v-for="item in creditTypeOptions" :key="item.value" :label="item.label" :value="item.value" :disabled="checkAvailableBalance(item.value)">
								</el-option>
							</el-select>
							<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
						</ValidationProvider>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<p class="text-muted">Transfer to :</p>
				</b-col>
				<b-col cols="12">
					<table class="table w-100">
						<thead>
							<tr>
								<th>Receiver User</th>
								<th>Trf Qty</th>
								<th>#</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in formParams.receiverList">
								<td>
									<b-form-group class="mb-0">
										<el-select v-model="formParams.receiverList[index].user_id" filterable placeholder="Select User">
											<el-option v-for="item in userOptions" :key="item.id" :label="item.name" :value="item.id">
											</el-option>
										</el-select>
									</b-form-group>
								</td>
								<td width="30%">
									<b-form-group class="mb-0">
										<el-input placeholder="Qty" type="number" v-model="formParams.receiverList[index].qty"
											:step="(formParams.credit_type == 'POINTS') ? '0.01' : '1'" min="0" :max="maxTransfer"></el-input>
									</b-form-group>
								</td>
								<td width="5%">
									<el-button type="danger" class="text-center" @click="removeReceiver(index)"><b-icon
											icon="trash"></b-icon></el-button>
								</td>
							</tr>
						</tbody>
						<tfoot>
							<tr>
								<td colspan="3">
									<b-button variant="info" class="btn-header" @click="addReceiver()">Add Receiver</b-button>
								</td>
							</tr>
						</tfoot>
					</table>
				</b-col>
			</b-row>
			<b-row align-v="center" class="py-3">
				<b-col cols="12">
					<b-button variant="primary" class="btn-header btn-block" @click="submitTransfer()">Proceed</b-button>
				</b-col>
			</b-row>
		</b-container>

	</el-drawer>
</template>
<script>
import { Drawer, Select, Option, Input, Button, DatePicker } from 'element-ui'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { useAuthStore } from '@/stores/authStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { mapActions, mapState } from 'pinia'
import {
	helperFunctionMixin,
	notifyFunctionMixin,
	axios,
	services,
	getHeader,
	debounce,
	swal
} from '@/assets/js/httpImports.js'
import _ from 'lodash'
export default {
	// props: {
	// 	prod_type: String
	// },
	mixins: [
		helperFunctionMixin,
		notifyFunctionMixin
	],
	components: {
		ValidationObserver,
		ValidationProvider,
		[Input.name]: Input,
		[Button.name]: Button,
		[Select.name]: Select,
		[Option.name]: Option,
		[Drawer.name]: Drawer
	},
	computed: {
		...mapState(useAuthStore, ['auth_user']),
		...mapState(useAccessControlStore, ['userList']),
		userOptions() {
			let self_id = this.auth_user.id;
			if(this.auth_user.subscription.scrb_is_my_own){
				return this.userList.filter((item) => (item.id != self_id) );
			}else{
				return this.userList;
			}
		},
		remainBalanceReport() {
			let currentQty = this.auth_user.subscription.scrb_credit_report;
			if (this.formParams.credit_type == 'REPORT') {
				currentQty = currentQty - this.getTotalTransfer();
			}
			return currentQty;
		},
		remainBalancePoints() {
			let currentQty = this.auth_user.subscription.scrb_credit_points;
			if (this.formParams.credit_type == 'POINTS') {
				currentQty = currentQty - parseFloat(this.getTotalTransfer());
			}
			return currentQty;
		},
		remainBalanceFree() {
			let currentQty = this.auth_user.subscription.scrb_free_report;
			if (this.formParams.credit_type == 'FREE_REPORT') {
				currentQty = currentQty - parseInt(this.getTotalTransfer());
			}
			return currentQty;
		},
		maxTransfer() {
			if (this.formParams.credit_type == 'REPORT') {
				return this.remainBalanceReport;
			} else if (this.formParams.credit_type == 'POINTS') {
				return this.remainBalancePoints;
			} else if (this.formParams.credit_type == 'FREE_REPORT') {
				return this.remainBalanceFree;
			} else {
				return 0;
			}

		},
	},
	async created() {
		this.formParams.receiverList = [];
		this.formParams.receiverList.push({
			user_id: null,
			qty: null
		});
	},
	mounted() {
	},
	data() {
		return {
			show_drawer: false,
			creditTypeOptions: [
				{
					label: 'Credit Report',
					value: 'REPORT',
				},
				{
					label: 'Credit Points',
					value: 'POINTS',
				}
			],
			formParams: {
				credit_type: 'REPORT',
				receiverList: []
			}
		}
	},
	methods: {
		...mapActions(useAuthStore,['fetchUserInfo']),
		showDrawer() {
			this.show_drawer = !this.show_drawer;
		},
		closeDrawer() {
			this.show_drawer = false;
			this.$emit('close');
		},
		addReceiver() {
			this.formParams.receiverList.push({
				user_id: null,
				qty: null
			});
		},
		resetReciver(){
			this.formParams.receiverList = [];
			this.formParams.receiverList.push({
				user_id: null,
				qty: null
			});
		},
		removeReceiver(index) {
			this.formParams.receiverList.splice(index, 1);
		},
		checkAvailableBalance(credit_type){
			if (credit_type == 'REPORT') {
				return !(this.auth_user.subscription.scrb_credit_report > 0);
			} else if (credit_type == 'POINTS') {
				return !(this.auth_user.subscription.scrb_credit_points > 0);
			} else if (credit_type == 'FREE_REPORT') {
				return !(this.auth_user.subscription.scrb_free_report > 0);
			} else {
				return true;
			}
		},
		getTotalTransfer() {
			return this.formParams.receiverList.reduce((total, item) => {
				return (item.qty) ? (total + parseFloat(item.qty)) : total;
			}, 0);
		},
		submitTransfer() {
			let goodData = this.formParams.receiverList.filter((item) => ((item.user_id > 0) && (item.qty > 0)));
			let params = {
				from_scrb_id: this.auth_user.subscription.scrb_id,
				credit_type: this.formParams.credit_type,
				receivers: goodData
			};
			if (this.isEmpty(goodData)) {
				this.notifyError('Please Choose Receiver')
			} else {
				swal.fire({
					title: 'Are you sure?',
					text: "This process will deduct your credit balance",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, proceed!',
					didOpen: () => {
						// Set z-index directly on the Swal container
						const swalContainer = swal.getContainer();
						console.log(swalContainer);
						swalContainer.style.zIndex = 99999;
					}
				}).then((result) => {
					if (result.isConfirmed) {
						axios.post(services.billing + 'credit-balance/transfer-credit', params, { headers: getHeader() })
							.then(res => {
								this.notifySuccess('<b>Transfer Balance </b> - Successfully Transfer.')
								this.fetchUserInfo();
								this.closeDrawer();
							})
							.catch(e => {
								this.errorFunction(e)
							})

					}
				})
			}
		}
	}
}
</script>